var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolumeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_768_2059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 13.3378V6.65614C17.4995 6.36537 17.4222 6.07989 17.2758 5.82863C17.1295 5.57736 16.9193 5.36923 16.6667 5.22531L10.8333 1.88531C10.5795 1.74032 10.2923 1.66406 10 1.66406C9.7077 1.66406 9.42047 1.74032 9.16667 1.88531L3.33333 5.22531C2.8175 5.52114 2.5 6.06698 2.5 6.65698V13.3386C2.5 13.9295 2.8175 14.4745 3.33333 14.7695L9.16667 18.1095C9.42047 18.2545 9.7077 18.3307 10 18.3307C10.2923 18.3307 10.5795 18.2545 10.8333 18.1095L16.6667 14.7695C17.1825 14.4736 17.5 13.9278 17.5 13.3378Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 18.3333V10",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 9.99687L17.275 5.79688",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.72656 5.79688L10.0016 9.99687",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_768_2059"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeIcon);
export default __webpack_public_path__ + "static/media/volume-icon.1c8b7966cc0cb5918ae4d76fa1c8c91d.svg";
export { ForwardRef as ReactComponent };